(function () {
    'use strict';

    angular.module("imApp").factory("equipmentsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1364,
                    parameters: parms || {}
                });
            },
            listEquipments: function (parms) {
                return $ihttp.post({
                    method: 238,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
